import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useBlockNavigation } from '../../../../common/hooks/useBlockNavigation'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Element } from '../../../../common/html/element'
import { Radio } from '../../../../common/html/radio'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { resetStoreHeaderCompanyAnalysis } from '../../../../companyAnalysis/common/header/companyInfo/store/slice'
import { resetStore as resetStorePortfolioInsign } from '../../../../portfolioInsights/common/popupCompanyList/store/slice'
import { IGNORE_QUERY } from '../../constant'
import { jsonToString } from './helper'
import classes from './index.module.scss'
import {
  resetFullStoreDetailTemplate,
  selectCompanyType,
  selectDefaultTemplate,
  selectIsHasCompanyName,
  selectIsHasPortName,
  selectIsHasReportSubtitle,
  selectName,
  selectPanelById,
  selectPanelId,
  selectReportSubtitle,
  selectReportTitle,
  setBlankTemplate,
} from './store/slice'

const CheckOutScreen = ({ saveTemplate }) => {
  const dispatch = useDispatch()

  const defaultTemplate = useSelector(selectDefaultTemplate)
  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const name = useSelector(selectName)
  const companyType = useSelector(selectCompanyType)
  const reportTitle = useSelector(selectReportTitle)
  const isHasReportSubtitle = useSelector(selectIsHasReportSubtitle)
  const reportSubtitle = useSelector(selectReportSubtitle)
  const isHasCompanyName = useSelector(selectIsHasCompanyName)
  const isHasPortName = useSelector(selectIsHasPortName)

  const isNotHasChange =
    name.trim() === defaultTemplate.templateName &&
    jsonToString(panelId) === jsonToString(defaultTemplate.panelId) &&
    jsonToString(panelById) === jsonToString(defaultTemplate.panelById)

  const { showPrompt, confirmNavigation, cancelNavigation } =
    useBlockNavigation({
      isBlock: !!panelId.length && !isNotHasChange,
      ignoreSearch: IGNORE_QUERY,
    })

  const placeHolder = UseI18n('preferenceSetting.PLH_INPUT')

  const [isShowPopupSaveAs, setIsShowPopupSaveAs] = useState(false)
  const [isSaveAs, setIsSaveAs] = useState(false)
  const [valueInput, setValueInput] = useState('')

  useEffect(() => {
    if (!defaultTemplate.templateId) {
      setIsSaveAs(true)
    }
  }, [defaultTemplate.templateId])

  const showPopupSaveAs = () => {
    setIsShowPopupSaveAs(true)
  }

  const closePopupSaveAs = () => {
    cancelNavigation()
    setIsShowPopupSaveAs(false)
  }

  const changeInput = (e) => setValueInput(e.target.value)

  const clearSettingDynamic = () => {
    dispatch(setBlankTemplate())
    dispatch(resetStoreHeaderCompanyAnalysis())
    dispatch(resetFullStoreDetailTemplate())
    dispatch(resetStorePortfolioInsign())
  }

  const submit = async () => {
    setIsShowPopupSaveAs(false)

    const panels = panelId.map((id) => panelById[id])
    const data = {
      templateName: valueInput.trim(),
      templateData: {
        panels,
        reportTitle,
        isHasReportSubtitle,
        reportSubtitle,
        isHasCompanyName,
        isHasPortName,
      },
      companyType,
    }

    if (!isSaveAs) {
      data.templateId = defaultTemplate.templateId
      data.templateName = name.trim()
    }

    const result = await saveTemplate(data)

    if (result) {
      confirmNavigation()
    }
  }

  const actionNavigate = () => {
    confirmNavigation()
  }

  const isDisableSubmit = isSaveAs ? !valueInput?.trim() : !name?.trim()

  useEffect(() => {
    const reload = (e) => {
      e.stopImmediatePropagation()
    }

    window.addEventListener('beforeunload', reload)

    return () => {
      clearSettingDynamic()
      window.removeEventListener('beforeunload', reload)
    }
  }, [])

  return (
    <>
      <PopupAction
        isShow={showPrompt}
        title="preferenceSetting.SAVE_CHANGE"
        handleClose={cancelNavigation}
        btnCancel={{
          label: 'common.NO',
          event: actionNavigate,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: showPopupSaveAs,
          isI18n: true,
        }}
        disableKeyDown
      >
        <Translate value="preferenceSetting.SAVE_CHANGE_NOTE" />
      </PopupAction>
      <PopupAction
        isShow={isShowPopupSaveAs}
        title="preferenceSetting.SAVE_CHANGE"
        handleClose={closePopupSaveAs}
        btnCancel={{
          label: 'preferenceSetting.CANCEL',
          event: closePopupSaveAs,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'preferenceSetting.SAVE',
          event: submit,
          isI18n: true,
          disabled: isDisableSubmit,
        }}
      >
        <Element>
          {defaultTemplate.templateId && (
            <Element>
              <Radio
                title={
                  <>
                    <Translate value="preferenceSetting.SAVE_CHANGE_TO" /> "
                    {defaultTemplate.templateName}"
                  </>
                }
                isI18n={false}
                value={false}
                activeValue={isSaveAs}
                onChange={setIsSaveAs}
                titleStyle={{
                  fontWeight: 600,
                  color: '#3A414B',
                }}
              />
            </Element>
          )}
          <Element style={{ marginTop: defaultTemplate.templateId ? 14 : 0 }}>
            <Radio
              title="preferenceSetting.SAVE_AS"
              value={true}
              activeValue={isSaveAs}
              onChange={setIsSaveAs}
              titleStyle={{ fontWeight: 600, color: '#3A414B' }}
            />
            <Element className="mt1">
              <Element
                elementName="input"
                style={{ border: '1px solid #E0E0E0' }}
                className={classes.inputSaveAs}
                placeholder={placeHolder}
                value={valueInput}
                onChange={changeInput}
              />
            </Element>
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}

CheckOutScreen.propTypes = {
  defaultTemplateProp: PropTypes.object,
  saveTemplate: PropTypes.func,
}

CheckOutScreen.defaultProps = {
  saveTemplate: () => {},
}

export default CheckOutScreen
